import { APP_ROUTES } from 'app/constants';
import { MenuItem } from './menu.model';
import { Permission } from 'app/enums';

const USER_MENU: MenuItem = {
    translationKey: 'MENU.USER',
    icon: 'group',
    iconType: 'solid',
    route: APP_ROUTES.UserList,
    permissions: [Permission.ReadUser]
};

const DASHBOARD_MENU: MenuItem = {
    translationKey: 'MENU.DASHBOARD',
    icon: 'home',
    iconType: 'solid',
    route: APP_ROUTES.Dashboard,
    permissions: [Permission.ReadMeasurement]
};

const MEASUREMENT_MENU: MenuItem = {
    translationKey: 'MENU.MEASUREMENT',
    icon: 'assessment',
    iconType: 'solid',
    route: APP_ROUTES.MeasurementList,
    permissions: [Permission.ReadMeasurement]
};

const LOCATION_MENU: MenuItem = {
    translationKey: 'MENU.LOCATION',
    icon: 'location_on',
    iconType: 'solid',
    route: APP_ROUTES.LocationList,
    permissions: [Permission.ReadLocation]
};

const DEVICE_MENU: MenuItem = {
    translationKey: 'MENU.DEVICE',
    icon: 'pacemaker',
    iconType: 'solid',
    route: APP_ROUTES.DeviceList,
    permissions: [Permission.ReadDevice],
    exactMatch: true
};

const DEVICE_UPGRADE_MENU: MenuItem = {
    translationKey: 'MENU.DEVICE_UPGRADE',
    icon: 'upgrade',
    iconType: 'solid',
    route: APP_ROUTES.DeviceUpgrade,
    permissions: [Permission.ReadFirmware]
};

const FIRMWARE_MENU: MenuItem = {
    translationKey: 'MENU.FIRMWARE',
    icon: 'system_update',
    iconType: 'solid',
    route: APP_ROUTES.FirmwareList,
    permissions: [Permission.WriteFirmware],
    requiresUnrestricted: true
};

const TENANT_MENU: MenuItem = {
    translationKey: 'MENU.TENANT',
    icon: 'apartment',
    iconType: 'solid',
    route: APP_ROUTES.TenantList,
    permissions: [Permission.ReadTenant]
};

export const MENU: MenuItem[] = [
    DASHBOARD_MENU,
    MEASUREMENT_MENU,
    LOCATION_MENU,
    DEVICE_MENU,
    DEVICE_UPGRADE_MENU,
    FIRMWARE_MENU,
    USER_MENU,
    TENANT_MENU
];
